import { ROUTE_PATH, REGION_OPTIONS, STATE_OPTIONS, TEMPLATE_OPTIONS, BRANCH_OPTIONS, BATCH_OPTIONS } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmRadioModel, SmMetaSelectModel, SmMetaFileModel, SmBtnMetaModel, SmMetaTextAreaModel } from "common/models/utility-models/meta-model";




export class AlumniMetaModel extends FormMetaModel {
    filterMeta: any;
    constructor() {
        super('Your Profile', '', ROUTE_PATH.alumniForm, 8);
    }
    override initProperties(): any {
        const formInfo = super.initProperties();
        const profile_pic_path = new SmMetaFileModel(
            'profile_pic_path',
            'profile_pic_path',
            'file',
            false,
            'input-fg form-group col-lg-6 col-md-6',
            4,
            7,
            '',
            'singleimagepreview',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
            3000,
            250,
            510,
            'image',
            'profile_pic_path',
            false,
            false,
            2000,
            3000
        );
        const first_name = new SmMetaInputModel(
            'first_name',
            'first_name',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'First Name',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );

        const last_name = new SmMetaInputModel(
            'last_name',
            'last_name',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'Last Name',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );

        const mobile_number = new SmMetaInputModel(
            'mobile_number',
            'mobile_number',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'Mobile Number',
            'number',
            '',
            false,
            true,
            true,
            false,
            10,
            1
        );

        const email = new SmMetaInputModel(
            'email',
            'email',
            'input',
            true,
            'input-fg form-group col-6 col-md-6',
            2,
            3,
            'Email Id',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            5
        );

        // [a-z0-9._%-]+@[a-z0-9._%-]+\\.[a-z]{2,3}

        const gender = new SmRadioModel(
            'gender',
            'gender',
            'radio',
            false,
            'col-xs-12 col-sm-12 col-md-4 col-lg-4 main-gender',
            1,
            2,
            'Gender',
            'checkbox',
            '',
            true,
            true,
            true,
            false,
            0,
            0,
            false,
            false,
            { evalKey: '', evalParam: [] },
            '',
            2,
            [
                {
                    key: 'male',
                    value: ['off'],
                    label: 'Male',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                },
                {
                    key: 'female',
                    value: ['off'],
                    label: 'Female',
                    decisiveKey: 'val',
                    prop: { key: 'required', value: true }
                }
            ]
        );
        const name_of_college = new SmMetaInputModel(
            'name_of_college',
            'name_of_college',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'College Name',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );
        const college_address = new SmMetaInputModel(
            'college_address',
            'college_address',
            'input',
            true,
            'col-6 col-md-6',
            1,
            1,
            'College Address',
            'text',
            '',
            false,
            true,
            true,
            false,
            200,
            1
        );


        const branch_id = new SmMetaInputModel(
            'branch_id',
            'branch_id',
            'input',
            false,
            'col-12 col-md-3',
            1,
            1,
            'Branch',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );


        const placement_company_name = new SmMetaInputModel(
            'placement_company_name',
            'placement_company_name',
            'input',
            false,
            'col-12 col-md-3',
            1,
            1,
            'Company Name',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );
        const placement_company_location = new SmMetaInputModel(
            'placement_company_location',
            'placement_company_location',
            'input',
            false,
            'col-12 col-md-3',
            1,
            1,
            'Company Location',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );
        const placement_company_designation = new SmMetaInputModel(
            'placement_company_designation',
            'placement_company_designation',
            'input',
            false,
            'col-12 col-md-3',
            1,
            1,
            'Company Designation',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );

        const other = new SmMetaTextAreaModel(
            'other',
            'other',
            'SimpleTextarea',
            false,
            'col-12 ',
            1,
            2,
            'Other Information (Working on a start up, working with any company,further study details, etc)',
            'textarea',
            '',
            false,
            true,
            true,
            false,
            250,
            0,
            false,
            false
        );

        // const region = new SmMetaSelectModel(
        //     'region',
        //     'region',
        //     'ng-select',
        //     false,
        //     'col-12 col-md-4 mt-3',
        //     1,
        //     8,
        //     'Region',
        //     'select',
        //     '',
        //     true,
        //     true,
        //     true,
        //     false,
        //     0,
        //     0,
        //     false,
        //     REGION_OPTIONS,
        //     'zone_name',
        //     'id',

        // );
        // const state_id = new SmMetaSelectModel(
        //     'state_id',
        //     'state_id',
        //     'select',
        //     false,
        //     'col-12 col-md-4 mt-3',
        //     1,
        //     8,
        //     'State',
        //     'select',
        //     '',
        //     true,
        //     true,
        //     true,
        //     false,
        //     0,
        //     0,
        //     false,
        //     STATE_OPTIONS,
        //     'stateName',
        //     'stateID',

        // );

        // const district = new SmMetaSelectModel(
        //     'district',
        //     'district',
        //     'select',
        //     true,
        //     'col-12 col-md-4 mt-3',
        //     1,
        //     1,
        //     'District',
        //     'select',
        //     '',
        //     false,
        //     true,
        //     true,
        //     false,
        //     0,
        //     0,
        //     false,
        //     TEMPLATE_OPTIONS,
        //     'name',
        //     'name'



        // );

        const consent:any = ""
        // const save = new SmBtnMetaModel('Save', 'primary', true, false, true, false);

        const buttons = {
            submit: new SmBtnMetaModel('Save', '', true, false, true, true),
            isFormControl: false,
        };
        return {
            formInfo,
            buttons,
            profile_pic_path,
            first_name,
            last_name,
            mobile_number,
            email,
            gender,
            branch_id,
            name_of_college,
            college_address,
            placement_company_name,
            placement_company_location,
            placement_company_designation,
            other,
            // district,
            // state_id,
            // region
            consent

        }
    }
} 